module.exports = "/images/no-avatar-img.png?7d62e49f5f4f1b9047f61041c8e39422";